import React from "react";

import { Container, Link, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";

import { S3_BUCKET } from "../../../constants";
import { StyledTable } from "../Styles/DonationTable";

export default function({donationsList}) {
    return <Container style={{p: 0, overflow: 'auto'}}>
    <StyledTable>
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell key={headCell.id}>
                        <Typography>{headCell.label}</Typography>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
        <TableBody>
            {
                donationsList.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{row.donation_id}</TableCell>
                            <TableCell>{row.page_title}</TableCell>
                            <TableCell>{row.donation_amount}</TableCell>
                            <TableCell>{row.donation_type}</TableCell>
                            <TableCell>{row.donations_created_at}</TableCell>
                            <TableCell>{row.donation_status}</TableCell>
                            <TableCell>{row.display_name}</TableCell>
                            <TableCell>
                                {row.donation_status === 'Confirmed' && row.currency_code !== "CAD" ?
                                    <Link href={`${S3_BUCKET}receipt/Donation Receipt ${row.donation_id}.pdf`}>Download</Link> :
                                    <Typography>Not available</Typography>
                                }
                            </TableCell>
                        </TableRow>
                    );
                })}
        </TableBody>
    </StyledTable>
</Container>
}

const headCells = [
    {
        id: 'transaction',
        label: 'Transaction ID',
    },
    {
        id: 'donatedToPage',
        label: 'Donated To',
    },
    {
        id: 'amount',
        label: 'Amount Donated',
    },
    {
        id: 'donationType',
        label: 'Type',
    },
    {
        id: 'date',
        label: 'Date',
    },
    {
        id: 'status',
        label: 'Status',
    },
    {
        id: 'paymentMethod',
        label: 'Payment Method',
    },
    {
        id: 'receipt',
        label: 'Receipt',
    },
];